import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const userRealtimeListeners: SocketEventListener[] = [
  {
    event: 'userUpdated',
    handler: (msg: any) => {
      console.log('socket io - userUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.USER_UPDATED, msg);
    },
  },
];

export default userRealtimeListeners;
